module.exports = __webpack_public_path__ + "img/d2.9ad43b16.png";